import Spinner from "./Spinner";

export const RouteLoading = () => (
  <div role="status" aria-live="polite" aria-label="Loading">
    <Spinner loading />
  </div>
);
